import React from 'react';

const MongoDB_Validation = () => {
  return (
    <div>
      <h1>MongoDB_Validation Component</h1>
      <p>This is the MongoDB_Validation page.</p>
    </div>
  );
};

export default MongoDB_Validation;
